'use client';

import { LINK } from '@constants';
import { Box } from '@viewup/ui';
import { ErrorTemplate } from './_components/ErrorTemplate';

const NotFound = () => {
  return (
    <Box height='100svh' pt={64} style={{ margin: '0 auto', maxWidth: 440 }} width='100%'>
      <ErrorTemplate
        errorHandleButtonText='메인페이지로 돌아가기'
        onClickErrorHandle={() => {
          window.location.href = LINK.HOME;
        }}
        title={'존재하지 않는 페이지입니다.'}
      />
    </Box>
  );
};

export default NotFound;
